module.exports = __webpack_public_path__ + "img/pointlimit.34c2be09.png";